<template>
    <div class="container" v-if="open===false && ((staffs.pd && staffs.pd.id==user.id) || (staffs.qa&&staffs.qa.id==user.id) || info.admin==true)">
        <div class="online_manage">
            <h5>页面待审核</h5>
            <p style="display:inline-block">该数据专项页处于“预发布”阶段，请审核后进行操作。当前上线进度：</p>
            <page-status :status="status" style="display:inline-block; vertical-align:top;"/>
            <!-- admin的情况 -->
            <div style="float:right" v-if="status==5">
                <a-button type="primary" disabled v-if="status>2"><a-icon type="like"/>已通过</a-button>
            </div>
            <div style="float:right" v-else-if="status==4">
                <a-button type="primary" disabled v-if="(staffs.qa && staffs.qa.id==user.id || info.admin==true)"><a-icon type="dislike"/>已驳回</a-button>
                <a-button type="primary" disabled v-else><a-icon type="like"/>已通过</a-button>
            </div>
            <div style="float:right" v-else-if="status==3">
                <a-button type="primary" class="offline_btn" v-if="(staffs.qa && staffs.qa.id==user.id || info.admin==true)" @click="changeStatus(4)"><a-icon type="dislike" />驳回</a-button>
                <a-button type="primary"  v-if="(staffs.qa && staffs.qa.id==user.id || info.admin==true)" @click="changeStatus(5)"><a-icon type="like"/>通过</a-button>
                <a-button type="primary" disabled  v-if="!(staffs.qa && staffs.qa.id==user.id || info.admin==true)"><a-icon type="like"/>已通过</a-button>
            </div>
            <div style="float:right" v-else-if="status==2">
                <a-button type="primary" disabled v-if="(staffs.pd && staffs.pd.id==user.id || info.admin==true)"><a-icon type="dislike"/>已驳回</a-button>
            </div>
            <div style="float:right" v-else-if="status==1">
                <a-button type="primary" class="offline_btn" v-if="(staffs.pd && staffs.pd.id==user.id || info.admin==true)"  @click="changeStatus(2)"><a-icon type="dislike" />驳回</a-button>
                <a-button type="primary" v-if="(staffs.pd && staffs.pd.id==user.id || info.admin==true)"  @click="changeStatus(3)"><a-icon type="like"/>通过</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import PageStatus from './pagestatus'
import {Modal} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Modal);
export default {
    name: 'OnlineManage',
    components: {
        PageStatus,
    },
    computed: {
        info() {
            return this.$store.state.game.info
        },
        user() {
            return this.$store.state.user
        },
        staffs() {
            let staffs = this.$store.state.config.page.staffs
            return staffs?staffs:{}
        },
        status() {
            return this.$store.state.config.page.status
        },
        open() {
            return this.$store.state.config.page.open
        },
    },
    data() {
        return {
            modal:true
        }
    },
    methods: {
        changeStatus(status) {
            let self = this
            Modal.confirm({
                zIndex: 1030,
                title: status==2 || status==4?'驳回上线申请':'通过上线申请',
                content: status==2 || status==4?'你确认要驳回此数据专项页的上线申请吗？':'你确认要通过此数据专项页的上线申请吗？',
                onOk() {
                    self.$service.patchData(`${self.$service.api.manage.submodule}${self.$route.query.id}/status/`, {status}).then(data => {
                        self.$message.success("设置成功")
                        self.$store.commit('set_page_config', {id:'status', val:status})
                        if(status==5) {
                            self.$store.commit('set_page_config', {id:'open', val:true})
                        }
                        else {
                            self.$store.commit('set_page_config', {id:'open', val:false})
                        }
                    })
                },
                onCancel() {},
            });
        }
    }
}
</script>


<style lang="less" scoped>
.online_manage {
    width: 100%;
    height: 130px;
    background: #fff;
    border: 1px solid #DDDDDD;
    padding: 22px 28px 22px 76px;
    h5 {
        position: relative;
        color: #000;
        font-size: 14px;
        font-weight: bold;
        &:before {
            position: absolute;
            content: ' ';
            left: -48px;
            top: 0;
            width: 22px;
            height: 16px;
            background: url('../../assets/img/users.png') no-repeat;
        }
    }
    .offline_btn {
        background:#F04864; 
        border-color:#F04864; 
        margin:0 10px 0 0;
    }
}
</style>